module.exports = __webpack_public_path__ + "media/images/hp_quiz/logo-ed908c7acacd61fb46b274f3e24ff58d.png";